<template>
  <div class="relative overflow-y-hidden bg-gradient-to-r from-[#737DD8] via-[#737DD8] to-[#737DD8] ">
     <!-- 18+ Age Verification Modal -->
     <WarnModal
      v-if="currentStep === 1"
      :isVisible="showAgeModal"
      title="Age Verification"
      message="Are you 18 years old or older? You must be at least 18 years old to access this site."
      confirmText="Yes"
      cancelText="No"
      @confirm="onAgeConfirmed"
      @cancel="onAgeRejected"
    />
    
     <!-- Gambling Responsibility Modal -->
     <WarnModal
      v-if="currentStep === 2"
      :isVisible="showAgeModal"
      title="Gambling Responsibilities"
      message="Do you accept the risks and responsibilities of gambling? Please gamble responsibly."
      confirmText="Accept"
      cancelText="Reject"
      @confirm="onResponsibilitiesAccepted"
      @cancel="onResponsibilitiesRejected"
    />

     <!-- Apology Section -->
     <div v-if="showApology" class="flex items-center justify-center min-h-screen px-4 text-center bg-top bg-no-repeat bg-cover bg-error-bg">
      <div>
        <h1 class="py-2 mb-4 text-4xl font-bold text-red-600 bg-white rounded-full md:text-5xl">We're sorry!</h1>
        <p class="text-lg text-white md:text-xl">
          You must meet all conditions to enter this site.
        </p>
      </div>
    </div>

     <!-- Main Content -->
     <div v-else>
    <section
      class="h-full overflow-hidden max-h-[2220px] sm:max-h-[2220px] md:max-h-[2400px] xl:max-h-[2400px] relative bg-gradient-to-r from-[rgba(125, 81, 163, 0)] to-[rgba(115, 125, 216, 1)]"
      style="background: linear-gradient(to bottom, rgba(125, 81, 163, 0), rgba(115, 125, 216, 1));"
      id="home">

      <img src="../assets/circle.png" alt="Circle 1"
        class="hidden md:block absolute bottom-[20px] right-[120px] md:-right-[60px] w-[320px] h-[320px] rounded-full object-contain">
      <img src="../assets/circle.png" alt="Circle 2"
        class="hidden md:block absolute bottom-[200px] -left-[100px] w-[440px] h-[440px] rounded-full object-contain">
      <!-- Background Image -->
      <!-- class="absolute inset-0 object-cover w-full h-full bg-center bg-repeat-y -z-10"  -->
      <img src="@/assets/hero-bg.png"
        class="block xl:hidden  z-10 w-full h-full max-h-[620px] sm:max-h-[700px] md:max-h-[740px] lg:max-h-[780px]  xl:max-h-full absolute inset-0 object-cover xl:object-contain xl:object-top object-bottom bg-repeat-y"
        alt="background-image" />
      <img src="@/assets/hero-bg-xl.png"
        class="absolute inset-0 z-10 hidden object-cover object-bottom w-full bg-repeat-y xl:block xl:max-h-full xl:object-cover xl:object-top"
        alt="background-image" />

      <!-- Content Container -->
      <div
        class="z-30 flex flex-col items-center justify-center w-full px-10 pt-20 pb-20 sm:px-14 sm:pt-20 md:pt-20 lg:pt-[70px] 2xl:pt-28 lg:px-40 xl:px-72 xl:pt-20 2xl:px-80">
        <!-- Hero Image (Responsive Display) -->
        <div class="flex flex-col items-center justify-center">

          <!-- Desktop Image -->
          <img v-motion-pop-visible src="@/assets/hero-hanvee.png"
            class="z-20 block w-[90%] sm:w-[80%] 2xl:w-full mt-10" alt="desktop-title-text" />

          <!-- Hero Button Section -->
          <div v-motion-pop-visible
            class="flex flex-nowrap sm:flex-row flex-col w-full justify-center items-center gap-4 lg:gap-y-12 lg:gap-x-4 mt-6 md:mt-12 z-20 mb-[86px] md:mb-[122px]">
            <div class="relative h-[72px] w-full md:w-[300px] rounded-full
  transition-shadow duration-200 shadow-[0_0_20px_1px_rgba(255,37,47,0.2),0_0_20px_4px_rgba(166,42,255,0.2)]">
              <div
                class="absolute inset-0 m-[2px] rounded-full bg-white overflow-hidden flex items-center justify-center"
                  style="box-shadow: inset 8px -6px 15.4px 3px rgba(68, 50, 81, 0.5);"
                >
                <a href="https://stake.ceo/?offer=hanvee&c=hanvee" class="z-10 px-14 py-6 text-md font-bold text-[#090B2A] 
    text-center whitespace-nowrap" style="font-family: Lato, sans-serif;">
                  REGISTER ON STAKE.CEO
                </a>
              </div>
            </div>

            <div
              class="relative h-[72px]  w-full md:w-[300px] rounded-full 
            transition-shadow duration-200 shadow-[0_0_20px_4px_rgba(255,37,47,0.2),0_0_20px_4px_rgba(166,42,255,0.2)]">
              <div class="absolute inset-0 m-[2px] rounded-full bg-[#373E7A] 
              overflow-hidden shadow-inner flex items-center justify-center"
                style="box-shadow: inset 8px -6px 15.4px 3px rgba(68, 50, 81, 0.75);"
              >
                <a href="https://kick.com/hanvee"
                  class="z-10 py-6 font-bold text-center text-white px-14 text-md whitespace-nowrap"
                  style="font-family: Lato, sans-serif;">
                  WATCH STREAM AT KICK.COM
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="z-20 flex flex-col items-center justify-between w-full mt-36 gap-y-6 md:gap-y-0 gap-x-6 lg:gap-x-12">

          <div class="text-[32px] md:text-7xl lg:text-4xl text-white leading-10  font-bold text-center font-montserrat"
           style="text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);"
          >
           WATCH MY LIVESTREAM
          </div>

          <!-- Left Section -->
          <div class="flex flex-col items-start justify-center md:w-[80%] lg:w-full gap-8 lg:flex-row mt-10 md:mt-20">
            <!-- Live banner mobile -->
            <div v-motion-slide-visible-left
              class="flex flex-col items-center w-full bg-black text-center rounded-lg gap-y-2 bg-opacity-70 backdrop-blur-lg lg:hidden bg-[url('@/assets/live-banner-bg.png')] bg-cover bg-center bg-no-repeat p-4">
              <img src="@/assets/hanvee-logo.png" alt="live-banner-logo" class="w-1/2">
              <div class="flex flex-col mt-4 gap-y-2">
                <h1 class="text-xl font-bold text-white">PLAY WHERE I PLAY!</h1>
                <h2 class="text-lg font-bold text-white ">LIVE EVERYDAY<span></span> @ 7:30 PM GMT </h2>
              </div>
            </div>

            <!-- Live banner desktop -->
            <div v-motion-slide-visible-left
              class="flex-col items-center justify-center bg-black h-full py-6 xl:py-[42px] 2xl:py-[45px] w-[300px] text-center rounded-lg gap-y-2 bg-opacity-70 backdrop-blur-lg hidden lg:flex bg-[url('@/assets/live-banner-bg.png')] bg-cover bg-center bg-no-repeat">
              <img src="@/assets/hanvee-logo.png" alt="live-banner-logo" class="w-[70%]">
              <div class="flex flex-col mt-4 gap-y-2">
                <h1 class="text-white text-[2vw] xl:text-xl 2xl:text-2xl">PLAY WHERE I PLAY!</h1>
                <h2 class="text-white text-[1.1vw] xl:text-xs 2xl:text-sm ">LIVE EVERYDAY<span></span> @ 7:30 PM GMT
                </h2>
              </div>
            </div>
            <!-- Live Stream Section -->
            <div v-motion-slide-visible-left
              class="w-full lg:w-[600px] xl:w-[660px] bg-black bg-opacity-70 backdrop-blur-lg rounded-xl">
              <div class="flex items-center justify-center w-full px-4 py-10">
                <iframe src="https://player.kick.com/hanvee" frameborder="0" scrolling="no" allowfullscreen="true"
                  class="w-full h-full rounded-xl aspect-video">
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <SocialSection />
    <LeaderboardSection />
    <PromotionSection />
    </div>
  </div>
</template>

<script>
import LeaderboardSection from "@/sections/LeaderboardSection.vue";
import PromotionSection from "@/sections/PromotionSection.vue";
import SocialSection from "@/sections/SocialSection.vue";
import WarnModal from "@/components/WarnModal.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    PromotionSection,
    LeaderboardSection,
    SocialSection,
    WarnModal,
  },
  data() {
    return {
      loading: false,
      showAgeModal: true,
      showApology: false,
      currentStep: 1, // Track the current step
    };
  },
  methods: {
    onAgeConfirmed() {
      this.currentStep = 2; // Move to the next step (responsibility modal)
    },
    onAgeRejected() {
      this.showAgeModal = false;
      this.showApology = true; // Show apology for age rejection
    },
    onResponsibilitiesAccepted() {
      this.showAgeModal = false; // Hide modal and allow access
    },
    onResponsibilitiesRejected() {
      this.showAgeModal = false;
      this.showApology = true; // Show apology for rejecting responsibilities
    },
  },
  mounted() {
    this.$emit("sections-ready");
  },
});
</script>

<style scoped>
#promo-card {
  background-image: url("../assets/promo-card.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>